import React from "react";

function Sponsors() {
  const sponsorTiers = [
    {
      tier: "Blue and Gold Legacy",
      sponsors: [
        {
          logo: require("../Assets/Sponsors/Gold/Logo1.png"),
          name: "White Furniture",
          website: "https://www.whitefurniture.com/",
          phone: "(734) 282-2155",
          note: "The best in home furniture & mattress at discount prices",
        },
        {
          logo: require("../Assets/Sponsors/Gold/Stroia.png"),
          name: "Stroia School of Driving",
          website: "https://stroiaschoolofdriving.com/",
          phone: "(734) 284-6175",
          note: "Your Key To The Road",
        },
      ],
    },
    {
      tier: "Season",
      sponsors: [
        {
          logo: require("../Assets/Sponsors/Silver/Logo1.jpg"),
          name: "Five Iron Golf",
          website: "https://fiveirongolf.com/",
          phone: "1 (800) 513-5153",
          note: "Redefining indoor golf and revolutionizing the way you play, practice, and party",
        },
        {
          logo: require("../Assets/Sponsors/Silver/ParkAthletic.jpg"),
          name: "Park Athletics",
          website: "https://parkathletic.weebly.com/",
          phone: "1 (313) 386-6570",
          note: "Park Athletics is a vibrant sporting goods store located in Allen Park, MI, dedicated to providing athletes and fitness enthusiasts with high-quality gear and apparel.",
        },
      ],
    },
    {
      tier: "Team",
      sponsors: [
        {
          logo: require("../Assets/Sponsors/Bronze/Logo1.png"),
          name: "The Taco Stand - Riverview",
          website: "https://www.thetacostandtaqueria.com/",
          phone: "(734) 258-8264",
          note: "Casual restaurant turning out burritos, quesadillas, and other Mexican favorites, including a kids menu",
        },
        {
          logo: require("../Assets/Sponsors/Bronze/Logo2.png"),
          name: "Allegra Printing",
          website: "https://www.allegramarketingprint.com/",
          phone: " (734) 284-5330",
          note: "Allegra is a full-service marketing company providing customized marketing, printing, mailing and signage solutions to meet your business goals.",
        },
        {
          logo: require("../Assets/Sponsors/Bronze/Logo3.png"),
          name: "Detroit City Distillery",
          website: "https://www.detroitcitydistillery.com/",
          phone: "(313) 338-3760",
          note: "Relaxed distillery & tasting room for creative cocktails made with small-batch whiskey, gin & vodka",
        },
        {
          logo: require("../Assets/Sponsors/Bronze/GlowHairSalon.jpg"),
          name: "Glow Hair Salon",
          website: "https://www.facebook.com/glowtrenton/",
          phone: "(734) 307-7490",
          note: "Premium hair salon offering cutting-edge styling and treatments",
        },
        {
          logo: require("../Assets/Sponsors/Bronze/Jerrys.jpg"),
          name: "Jerry's Market",
          website: "https://jerrysfoodmarket.com/",
          phone: "(734) 283-0700",
          note: "Find all your grocery needs at Jerry's Food Market. We offer a wide range of fresh produce, pantry staples, and more. Visit our grocery store today!",
        },
        {
          logo: require("../Assets/Sponsors/Bronze/kow.png"),
          name: "Knock on Wood Design Studio",
          website: "https://www.kowdesignstudio.com/",
          phone: " (734) 789-0138",
          note: "Knock on Wood Design Studio is a cozy studio where you can come relax, unwind & paint. 🎨 Your one-stop for all things crafty! ✨",
        },
        {
          logo: require("../Assets/Sponsors/Bronze/Lowes.jpg"),
          name: "Lowe's",
          website: "https://www.lowes.com/",
          phone: " (734) 284-6843",
          note: "Home Improvement Made Easy — Save More at Lowes.Start Your Home Transformation Journey Today.",
        },
        {
          logo: require("../Assets/Sponsors/Bronze/HenryFord.png"),
          name: "the Henry Ford",
          website: "https://www.thehenryford.org/",
          phone: " +1(313) 937-6799",
          note: "Step into a World Where Past Innovations Fuel the Imagination of Generations to Come.",
        },
                {
          logo: require("../Assets/Sponsors/Bronze/Whiskeys.jpg"),
          name: "Whiskeys on the Water",
          website: "https://whiskeysonthewaterwyandotte.com/",
          phone: "(734)-720-9738",
          note: "Located in Wyandotte, Whiskeys on the Water is an American dining restaurant and bar that serves our community with pride.",
        },
      ],
    },
    {
      tier: "Community Partners / Special Projects",
      sponsors: [
        {
          logo: require("../Assets/Sponsors/Special/Logo1.jpg"),
          name: "Meijer",
          website: "https://www.meijer.com/",
          phone: "",
          note: "FRHSR Thanks Meijer for a generous gift helping keep our athletes fed and fueled.",
        },
        {
          logo: require("../Assets/Sponsors/Special/grobbels.png"),
          name: "Grobbel's Premium Meats",
          website: "https://www.grobbel.com/",
          note: "We thank Grobbel's Premium Meats for a generous gift supplying our Corn beef and cabbage for our annual St. Patrick's Day fundraiser.",
        },
        {
          logo: require("../Assets/Sponsors/Special/elliotts.png"),
          name: "Elliott's Bakery",
          website: "https://elliottsbakery.com/",
          phone: "734-676-1940",
          note: "We thank Elliot's Bakery for a generous gift supplying our baked goods for our annual Luau fundraiser.",
        },

      ],
    },
  ];

  return (
    <div className="centered-page">
      <h2>Our Sponsors</h2>
      <p>
        We're grateful for the support of these organizations that help keep
        rowing accessible to all in Wyandotte.
      </p>

      {sponsorTiers.map((tierData) => (
        <div key={tierData.tier} style={{ marginTop: "3rem" }}>
          <h3
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              marginBottom: "2rem",
              textAlign: "left",
            }}
          >
            {tierData.tier} Sponsors
          </h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "2rem",
              marginBottom: "2rem",
            }}
          >
            {tierData.sponsors.map((sponsor, idx) => (
              <div
                key={idx}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "1.5rem",
                  textAlign: "center",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#fff",
                }}
              >
                <img
                  src={sponsor.logo}
                  alt={sponsor.name}
                  style={{
                    maxWidth: "100%",
                    height: "150px",
                    objectFit: "contain",
                    marginBottom: "1rem",
                  }}
                />
                <h4
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    marginBottom: "1rem",
                  }}
                >
                  {sponsor.name}
                </h4>
                <p
                  style={{
                    fontSize: "0.95rem",
                    margin: "0.5rem 0",
                    color: "#555",
                  }}
                >
                  <a
                    href={sponsor.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "rgb(22, 22, 116)",
                      textDecoration: "none",
                    }}
                  >
                    {sponsor.website}
                  </a>
                </p>
                <p
                  style={{
                    fontSize: "0.95rem",
                    margin: "0.5rem 0",
                    color: "#555",
                  }}
                >
                  <a
                    href={`tel:${sponsor.phone}`}
                    style={{
                      color: "rgb(22, 22, 116)",
                      textDecoration: "none",
                    }}
                  >
                    {sponsor.phone}
                  </a>
                </p>
                <p
                  style={{
                    fontSize: "0.9rem",
                    margin: "1rem 0 0 0",
                    color: "#666",
                    fontStyle: "italic",
                  }}
                >
                  {sponsor.note}
                </p>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Sponsorship Levels Section */}
      <div style={{ marginTop: "4rem", marginBottom: "2rem" }}>
        <h2 style={{ textAlign: "left", marginBottom: "2rem" }}>
          Sponsorship Levels
        </h2>

        {/* Team Sponsor */}
        <div
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#f8f9fc",
            borderRadius: "8px",
            textAlign: "left",
          }}
        >
          <h3
            style={{
              fontSize: "1.3rem",
              fontWeight: "bold",
              color: "rgb(22, 22, 116)",
              marginBottom: "0.75rem",
            }}
          >
            $100 Team Sponsor
          </h3>
          <ul style={{ marginLeft: "1.5rem", color: "#555" }}>
            <li>Special thank you recognition on Facebook page and website</li>
            <li>Recognition at our annual team banquet</li>
          </ul>
        </div>

        {/* Season Sponsor */}
        <div
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#f4f6fa",
            borderRadius: "8px",
            textAlign: "left",
          }}
        >
          <h3
            style={{
              fontSize: "1.3rem",
              fontWeight: "bold",
              color: "rgb(22, 22, 116)",
              marginBottom: "0.75rem",
            }}
          >
            $250 Season Sponsor
          </h3>
          <p
            style={{
              marginBottom: "0.75rem",
              color: "#555",
              fontWeight: "600",
            }}
          >
            All of the above plus...
          </p>
          <ul style={{ marginLeft: "1.5rem", color: "#555" }}>
            <li>Recognition featured on 25-26 regatta season banner</li>
          </ul>
        </div>

        {/* Blue and Gold Legacy */}
        <div
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#f8f9fc",
            borderRadius: "8px",
            textAlign: "left",
          }}
        >
          <h3
            style={{
              fontSize: "1.3rem",
              fontWeight: "bold",
              color: "rgb(22, 22, 116)",
              marginBottom: "0.75rem",
            }}
          >
            Blue and Gold Legacy Sponsor
          </h3>
          <p
            style={{
              marginBottom: "0.75rem",
              color: "#555",
              fontWeight: "600",
            }}
          >
            All of the above plus...
          </p>
          <ul
            style={{
              marginLeft: "1.5rem",
              color: "#555",
              marginBottom: "0.75rem",
            }}
          >
            <li>Name or business name on a team blade</li>
            <li>2 tickets to our annual RHS Rowing Luau Fundraiser</li>
          </ul>
          <p
            style={{ color: "#555", fontStyle: "italic", marginTop: "0.75rem" }}
          >
            Thank You!
          </p>
        </div>

        {/* Contact Info */}
        <div
          style={{
            marginTop: "3rem",
            padding: "1.5rem",
            backgroundColor: "#fff",
            border: "2px solid rgb(22, 22, 116)",
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <p
            style={{ fontSize: "1rem", color: "#555", marginBottom: "0.5rem" }}
          >
            If you have any questions, please email
          </p>
          <p
            style={{
              fontSize: "1rem",
              fontWeight: "600",
              marginBottom: "0.5rem",
            }}
          >
            <a
              href="mailto:friendsofrhsrowing@gmail.com"
              style={{ color: "rgb(22, 22, 116)", textDecoration: "none" }}
            >
              friendsofrhsrowing@gmail.com
            </a>
          </p>
          <p
            style={{
              fontSize: "1rem",
              fontWeight: "600",
              marginBottom: "1rem",
            }}
          ></p>
          <hr
            style={{
              border: "none",
              borderTop: "1px solid #ddd",
              margin: "1rem 0",
            }}
          />
          <p
            style={{
              fontSize: "0.95rem",
              color: "#666",
              marginBottom: "0.25rem",
            }}
          >
            Donations are tax deductible
          </p>
          <p style={{ fontSize: "0.95rem", color: "#666" }}>
            Letter of donation will be provided to donor
          </p>
        </div>
      </div>
    </div>
  );
}

export default Sponsors;
